import { PropTypes } from "prop-types";
import "./layout.scss";

const propTypes = {
  children: PropTypes.node.isRequired,
};

const Layout = ({ children }) => {
  return <div className="layout">{children}</div>;
};

Layout.propTypes = propTypes;

export default Layout;
